<?xml version="1.0" encoding="UTF-8"?>
<svg id="Livello_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32">
  <!-- Generator: Adobe Illustrator 30.7.0, SVG Export Plug-In . SVG Version: 2.1.4 Build 114)  -->
  <defs>
    <style>
      .st0 {
        fill: #515151;
      }
    </style>
  </defs>
  <path class="st0" d="M12.3,20.1c.7,0,1.2-.6,1.2-1.2s-.6-1.2-1.2-1.2-1.2.6-1.2,1.2.6,1.2,1.2,1.2Z"/>
  <path class="st0" d="M16.2,10.3c0-.2.2-.4.2-.5.5.1,1.3.4,3.1,0,2.4-.5,4.3-2.2,5-4.6.1-.4-.1-.9-.5-1l-.8-.2c-2.3-.7-4.8,0-6.5,1.6-.5-2.3-2.2-4.2-4.5-4.9l-.8-.2c-.4-.1-.9.1-1,.5-.1.4.1.9.5,1l.8.2c2.3.7,3.8,3,3.5,5.4,0,0,0,1.3-.9,2.9-5.1.8-8.9,5.2-8.9,10.5s4.8,10.7,10.7,10.7,10.7-4.8,10.7-10.7c0-5.8-4.7-10.6-10.5-10.7ZM22.6,5.5c-1.1,2.1-3.5,3.2-5.8,2.5,1.1-2.1,3.5-3.2,5.8-2.5ZM16.1,30c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9,8.9,4,8.9,8.9c0,4.9-4,8.9-8.9,8.9Z"/>
  <path class="st0" d="M20.5,22.7c-.4-.2-.9,0-1.1.3-.8,1.3-2,2.1-3.4,2.1s-2.6-.7-3.4-2.1c0,0,0,0,0,0-.2-.4-.8-.5-1.1-.3s-.5.8-.3,1.1c1.1,1.8,2.8,2.9,4.8,2.9s3.8-1,4.8-2.9c.2-.4,0-.9-.3-1.1Z"/>
  <path class="st0" d="M19.7,17.7c-.7,0-1.2.6-1.2,1.2s.6,1.2,1.2,1.2,1.2-.6,1.2-1.2-.6-1.2-1.2-1.2Z"/>
</svg>